import Overlay from "../../components/Overlay";
import {CloseIcon, MaximizeIcon, MinimizeIcon} from "../../utils/icons";
import {Colors} from "../../utils/style/colors";
import {IconButton} from "../../components/IconButton";
import {useTranslation} from "react-i18next";
import {Flex} from "../../components/Container/Flex";
import {CircularProgress} from "@mui/material";
import * as React from 'react';
import {createStructuredSelector} from "reselect";
import {selectShowWiki} from "../../redux/selectors/app.selectors";
import {connect} from "react-redux";
import {compose} from "redux";
import {setShowWiki} from "../../redux/actions/app.actions";
import {getWhitelabel} from "../../env";

const WikiOverlay = props => {
    const [t] = useTranslation();
    const [loading, setLoading] = React.useState(true);
    const [minimized, setMinimized] = React.useState(false);

    let {
        showWiki,
        setShowWiki
    } = props;
    React.useEffect(() => {
        if (!showWiki) return;
        setMinimized(false);
        setLoading(true);
    }, [showWiki]);
    if (!showWiki) return null;
    if(showWiki === true) showWiki = '/';
    
    return (
        <Overlay style={{
            top: minimized ? 'calc(100% - 58px)' : 0,
            transition: 'all .3s',
            zIndex: 10000,
        }}>
            <div
                style={{
                    top: 0,
                    border: 0,
                    position: "absolute",
                    left: 0,
                    width: '100%',
                    height: 'calc(100% - 30px)',
                }}>
                <Flex justify="flex-end" align="center" style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    left: 0,
                    height: 62,
                    background: 'black',
                    zIndex: -1
                }} />
                {loading && (
                    <Flex justify="center" style={{
                        position: 'absolute',
                        top: 60,
                        right: -2,
                        left: 0,
                        bottom: 0,
                        background: 'white',
                        paddingTop: '20%'
                    }}>
                        <CircularProgress/>
                    </Flex>
                )}
                <iframe
                    title="SOSvolaris Wiki"
                    style={{
                        marginTop: -2,
                        border: 0,
                        width: '100%',
                        height: '100%',
                    }}
                    onLoad={() => setLoading(false)}
                    src={getWhitelabel().simpleView ? `https://help.mobielenoodknop.nl${showWiki}` : `https://wiki.sosvolaris.com${showWiki}`}
                />
                <Flex justify="flex-end" align="center" style={{
                    position: 'absolute',
                    top: 0,
                    right: -2,
                    left: minimized ? 0 : undefined,
                    height: 60
                }}>
                    <Flex style={{width: minimized ? '100%' : undefined, height: '100%'}} justify="flex-end">
                        {minimized && <Flex style={{width: 300, height: '100%'}}/>}
                        {minimized && <Flex style={{flex: 1, background: 'black', height: '100%'}} />}
                        <Flex style={{background: 'black', height: '100%'}}>
                            {minimized ? (
                                <IconButton onClick={() => setMinimized(false)} tooltip={t('maximize')}>
                                    <MaximizeIcon color={Colors.white} size={1.5}/>
                                </IconButton>
                            ) : (
                                <IconButton onClick={() => setMinimized(true)} tooltip={t('minimize')}>
                                    <MinimizeIcon color={Colors.white} size={1.5}/>
                                </IconButton>
                            )}
                            <IconButton onClick={() => setShowWiki(false)} tooltip={t('close')}>
                                <CloseIcon color={Colors.white} size={1.5}/>
                            </IconButton>
                        </Flex>
                    </Flex>
                </Flex>
            </div>
        </Overlay>
    );
}


function mapDispatchToProps(dispatch) {
    return {
        setShowWiki: s => dispatch(setShowWiki(s))
    };
}

const mapStateToProps = createStructuredSelector({
    showWiki: selectShowWiki
});
export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(WikiOverlay);